import { styled } from '@mui/material';

export const sxStyles = {
  filterSectionTitle: {
    marginBottom: '1.5rem',
    marginLeft: '0.5rem',
  },
  clearBtn: {
    display: 'flex',
    margin: '1.5rem 0',
    fontSize: '0.75rem',
    transition: 'background-color 0.5s',

    svg: {
      marginLeft: '0.5rem',
    },
  },
  selectedValue: {
    margin: '0 0.25rem 0.5rem 0.25rem',
    maxWidth: '255px',
  },
  drawerPaper: {
    '& .MuiDrawer-paper': {
      width: '100%',
      maxHeight: '100%',
      overflowY: 'auto',
      pt: 6,
      pb: 4,
      px: 2,
    },
  },
};

export const StyledFilterSectionWrap = styled('form')(({ theme }) => ({
  paddingRight: '0.5rem',
  marginRight: '1rem',
  marginTop: '0.5rem',
  maxWidth: '304px',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    marginRight: 0,
  },

  [theme.breakpoints.down('xs')]: {
    marginLeft: 0,
  },
}));

export const StyledDesktopFiltersWrap = styled('div')(({ theme }) => ({
  width: 'auto',
  overflow: 'visible',
  visibility: 'visible',
  height: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    visibility: 'hidden',
  },
}));
